<!-- eslint-disable -->
<template lang="pug">
    .olympiad-preview
        .olympiad-preview__background-image
        .olympiad-preview__logo
            img.olympiad-preview__image(:src="olympiad.logo")
        .olympiad-preview__title(v-text="olympiad.title")
        .olympiad-preview__container
            .olympiad-preview__name(v-text="olympiad.name")
            .olympiad-preview__date(v-if="!withoutDate")
                svg-icon.olympiad-preview__icon(name="calendar" height="24" width="24")
                span.olympiad-preview__date-text {{ $i18n.t('olympiads.olympiads_previewWithDecorations_held') }} {{ date }}
            =" "
        .olympiad-preview__additional-text
            span.header__text
                slot
</template>

<script>
    /*eslint-disable*/
    import moment from 'moment'

    export default {
        props: {
            olympiad: Object,
            withoutDate: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.$nextTick(() => {
                let background = document.querySelector('.olympiad-preview__background-image');
                let container = document.querySelector('.olympiad-preview');
                let text = document.querySelector('.olympiad-preview__additional-text');
                if (background && container && text) {
                    background.style.height = container.clientHeight - text.clientHeight + 20 + 'px';
                }
            });
        },
        computed: {
            date () {
                return moment(this.olympiad.date).format('ll');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-preview {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        position: relative;
    }

    .olympiad-preview__background-image {
        position: absolute;
        background: url("../../assets/images/battles/result/victory-background.png");
        //height: 400px;
        left: -18px;
        top: -18px;
        width: calc(100% + 36px);
        opacity: .5;
        @include media($md) {
            left: -42px;
            top: -42px;
            width: calc(100% + 84px);
        }
    }

    .olympiad-preview__logo {
        text-align: center;
        margin: 15px 0;
        z-index: 1;
    }

    .olympiad-preview__image {
        border-radius: 50%;
        max-width: 100px;
        max-height: 100px;
    }

    .olympiad-preview__title {
        text-align: center;
        font-size: 14px;
        margin-bottom: 20px;
        z-index: 1;
    }

    .olympiad-preview__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;
    }

    .olympiad-preview__name {
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 15px;
        @include media($md) {
            font-size: 20px;
        }
        @include media($xlg) {
            font-size: 22px;
        }
    }

    .olympiad-preview__date {
        font-size: 14px;
        display: flex;
        margin-bottom: 35px;
        z-index: 1;
    }

    .olympiad-preview__icon {
        color: $hsl-color-green-58;
        margin-right: 15px;
    }

    .olympiad-preview__date-text {
        padding-top: 4px;
    }

    .olympiad-preview__additional-text {
        text-align: center;
        font-size: 24px;
        font-weight: 700;
        color: #FF7245;
        z-index: 1;
        @include media($md) {
            font-size: 30px;
        }
    }
</style>
